import React from "react";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";

const PickupPointSelect = ({ onPickupPointChange, disabled }) => {
  const handleChange = (e) => {
    const value = e.target.value;
    onPickupPointChange(value);
  };

  return (
    <TextField
      select
      required
      disabled={disabled}
      onChange={handleChange}
      label="Select Pickup Point"
      variant="outlined"
      sx={{
        width: "50%",
        marginTop: "1em",
      }}
    >
      <MenuItem value="Anderson Gate">Anderson Gate</MenuItem>
      <MenuItem value="King Nehale Gate">King Nehale Gate</MenuItem>
      <MenuItem value="Von Lindequist Gate">Von Lindequist Gate</MenuItem>
      <MenuItem value="Outjo">Outjo</MenuItem>
      <MenuItem value="Etosha Trading Post">Etosha Trading Post</MenuItem>
      <MenuItem value="Etosha Safari Camp">Etosha Safari Camp</MenuItem>
    </TextField>
  );
};

export default PickupPointSelect;
